import { Injectable } from '@angular/core';
import { DashboardCta } from '@bluecrew/crew-member-backend-angular-client';
import { NavController } from '@ionic/angular';
import { Browser } from '@capacitor/browser';
import '../../plugins/navigation/navigation-plugin';
import { NavigationPlugin } from '@plugins/navigation/navigation-plugin';
import { BrowserService } from './browser.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CtaHandlerService {
    constructor(
        private navCtrl: NavController,
        private browserService: BrowserService
    ) {
    }

    async handle({ url, openType }: DashboardCta) {
        const byType: { [K in DashboardCta.OpenTypeEnum]: () => Promise<unknown> } = {
            inAppBrowser: () => Browser.open({ url }),
            ionicNavigation: () => this.navCtrl.navigateForward(url),
            nativeNavigation: () => NavigationPlugin.goToNativeScreen({ path: url }),
            externalUniversalUrl: () => Promise.resolve(window.open(url)),
            legacyWebNavigation: () => this.browserService.open(`${environment.WEB_V1_URL}/app.html#!${url}`)
        };
        await byType[openType]();
    }
}
